import Layout from '@/layout'

import myCourse from './modules/myCourse'
import userCenter from './modules/userCenter'
import activity from './modules/activity'
import notice from './modules/notice'
import thesis from './modules/thesis'
import myevents from './modules/myevents'

const routes = [
  {
    path: '/',
    title: '首页',
    component: Layout,
    key: 'index',
    redirect: '/dashboard',
    name: 'Index',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/HomeView.vue'),
        meta: { title: '首页', icon: 'dashboard', isShowSidebar: false }
      }
    ]
  },
  myCourse,
  myevents,
  activity,
  notice,
  thesis,
  {
    path: '/docs',
    title: '常用文档',
    component: Layout,
    redirect: '',
    children: [
      {
        path: '',
        name: 'DocsIndex',
        component: () => import('@/views/CommonDocs/index.vue'),
        meta: { title: '常用文档', isShowSidebar: false }
      }
    ]
  },
  userCenter,
  {
    path: '/force-assessment:id',
    title: '强制课程评估',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'forceAssessment',
        component: () => import('@/views/MyCourse/Assessment/detail.vue'),
        meta: { title: '强制课程评估', icon: 'dashboard', isShowSidebar: false }
      }
    ]
  }
]

export default routes
